import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {UrlStorageService} from '@app/services/utility/url-storage.service';

@Injectable({
  providedIn: 'root',
})
export class BackUrlGuard {
  constructor(private urlStorageService: UrlStorageService) {}

  readonly BACK_URL_KEY = 'backUrl';

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const backUrlKey = Object.keys(state.root.queryParams).find(
      (key) => key.toLowerCase() === this.BACK_URL_KEY.toLowerCase()
    );
    const backUrl = state.root.queryParams[backUrlKey];
    this.urlStorageService.storeValidUrlInSessionStorage(this.BACK_URL_KEY, backUrl);
    return of(true);
  }
}
